import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import axios from "axios";
import env from "./environment";

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: "es",
    wait: false,
    debug: true,
    saveMissing: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

// Resolves once the translations from the API are loaded (or the request fails),
// so the app is not rendered showing raw translation keys.
export const i18nReady = axios
  .get(`${env.api.url}/v1/languages/app`, {})
  .then((response) => {
    i18n.addResourceBundle("cat", "translation", response.data.data.cat);
    i18n.addResourceBundle("es", "translation", response.data.data.es);
    i18n.addResourceBundle("en", "translation", response.data.data.en);
  })
  .catch((error) => {});

i18n.on("missingKey", (lngs, namespace, key, res) => {
  console.log("miss", lngs, namespace, key, res);
});

export default i18n;
